import { withTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import LinearProgress from '@material-ui/core/LinearProgress';

const GradientLinearProgress = styled(LinearProgress)`
  > div {
    background-image: linear-gradient(
      ${props => props.theme?.brand?.gradient?.primary}
    );
    transition: transform 0.05s linear;
  }
  background: ${props => props.theme.palette.divider};
`;

export default withTheme()(GradientLinearProgress);
